/**
 * @module experience/change-msisdn
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const WEB_COMPONENT_CONSTANTS = {
  WEB_COMPONENT: 'WebComponent',
  CUSTOMER_PROFILE_SERVICE: 'CustomerProfileService',
  WEB_COMPONENT_MODULE: 'NewNumberModule',
  WEB_MODULE: 'WebModule',
  WEB_GEO_LOCATION:
    'https://api.mapbox.com/geocoding/v5/mapbox.places/{0},{1}.json?types=postcode&country=US,PR&access_token={2}',
  ALLOWED_ROUTES: [
    'product-selector',
    'plan-detail',
    'browse-phones',
    'browse-tablets',
    'browse-accessories',
  ],
};
